import { Card, Heading, Separator, Text } from "@radix-ui/themes";
import { FC } from "react";
import { GetOrderResponseType } from "../../../api";

type ShippingAddressProps = Pick<GetOrderResponseType, "shippingAddress">;

export const ShippingAddress: FC<ShippingAddressProps> = (props) => {
  const { shippingAddress } = props;
  return (
    <Card>
      <Heading as="h2">Lieferanschrift</Heading>
      <Separator my="1" size="4" />
      <Text as="p">{shippingAddress?.company1}</Text>
      <Text as="p">{shippingAddress?.company2}</Text>
      <Text as="p">{shippingAddress?.company3}</Text>
      <Text as="p">{shippingAddress?.company4}</Text>
      <Text as="p">{shippingAddress?.street}</Text>
      <Text as="p">
        {shippingAddress?.postalCode} {shippingAddress?.city}
      </Text>
      <Text as="p">{shippingAddress?.country}</Text>
    </Card>
  );
};
